export default ({ get, checkStatus, toJSON }) => ({
  getHeroUnit: (id) =>
    get(`universe/v2/hero_units/search?hero_unit_ids=[${id}]`)
      .then(checkStatus)
      .then(toJSON),
});
